import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'FacilityNationalFormulary',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewNationalFormularyPortfolioUi()) {
            this.logout();
            return;
        }
        if (this.isFacilityCenterRole()) {
            this.activeTab = 'myProducts';
        } else if (!this.isMinistryPortal) {
            this.activeTab = 'explore';
        }
        if (this.isMinistryPortal) {
            await this.loadBranches();
            this.syncFormularyRouteToState();
        }
        await this.loadFormularyCategories();
        if (this.activeTab === 'requests' && this.isMinistryPortal) {
            this.requestStatusFilter = 1;
        }
        if (this.activeTab === 'requests') {
            await this.loadRequests(1);
        } else if (!this.isMinistryPortal || this.selectedBranchId || this.activeTab === 'explore') {
            await this.loadGrid(1);
        }
    },

    computed: {
        effectiveGridScope() {
            if (this.activeTab === 'myProducts') return 'granted';
            return this.scopeFilter;
        },
        isMinistryPortal() {
            if (!this.loginDetails) return false;
            if (this.isFacilityCenterRole()) return false;
            return this.hasInventoryAndStockAccessUi() || this.canReviewProcurementRequestsUi();
        },
        branchQueryParam() {
            if (!this.isMinistryPortal) return null;
            const v = Number(this.selectedBranchId);
            return v > 0 ? v : null;
        },
        showNationalFormularyTabs() {
            if (this.isFacilityCenterRole()) return true;
            return this.isMinistryPortal;
        },
        exploreTabLabel() {
            return this.isMinistryPortal ? 'إضافة من القائمة النمطية' : 'طلب فتح مواد';
        },
        myProductsTabLabel() {
            return this.isMinistryPortal ? 'أصناف المرفق المعتمدة' : 'أصنافي المعتمدة';
        },
        showMyProductsEmptyHint() {
            return this.activeTab === 'myProducts'
                && !this.gridRows.length
                && this.pages === 0
                && (!this.isMinistryPortal || this.selectedBranchId);
        },
        formularyPageHeading() {
            if (!this.isMinistryPortal) return 'القائمة النمطية للمرفق';
            if (this.activeTab === 'requests') return 'طلبات اعتماد الأصناف';
            if (this.activeTab === 'explore') return 'إضافة أصناف لمرفق صحي';
            return 'أصناف المرفق المعتمدة';
        },
        formularyPageLead() {
            if (!this.isMinistryPortal) {
                return 'إدارة «أصنافي المعتمدة»، طلب فتح مواد من الوزارة، واستكشاف القائمة النمطية (~20 ألف بند) عبر تصفية متقدمة، نطاق أكواد، التصنيف الطبي، شكل الجرعة، لصق جماعي، أو استيراد Excel.';
            }
            if (this.activeTab === 'requests') {
                return 'استعراض طلبات فتح المواد الواردة من المرافق، فتح التفاصيل، واعتماد الطلب أو رفضه مع الملاحظات.';
            }
            if (this.activeTab === 'explore') {
                return 'حدّد المرفق، ثم ابحث في القائمة النمطية وفعّل الأصناف للمرفق أو تابع سلة الاختيار وطلبات فتح المواد من واجهة الوزارة.';
            }
            return 'عرض الأصناف المفعّلة للمرفق المحدد والربط مع سجل الأصناف وأرصدة المرفق.';
        },
        basketList() {
            return Object.values(this.basketById || {});
        },
        basketEligibleForRequestCount() {
            return this.basketList.filter((x) => !x.isGranted && !x.isPendingReview).length;
        },
        basketEligibleForGrantCount() {
            return this.basketList.filter((x) => !x.isGranted).length;
        },
        /** لوحة التفعيل المباشر من الوزارة على تبويب الأصناف المعتمدة (بدون دورة طلب). */
        showDirectGrantPanelOnMyProducts() {
            return this.isMinistryPortal && this.selectedBranchId && this.meta.canManageGrants;
        },
        myProductsMainColumnClass() {
            return this.showDirectGrantPanelOnMyProducts ? 'col-12 col-lg-8' : 'col-12';
        },
    },

    watch: {
        '$route.fullPath'() {
            if (!this.isMinistryPortal) return;
            const prevTab = this.activeTab;
            const prevBranch = Number(this.selectedBranchId) || null;
            this.syncFormularyRouteToState();
            const tabChanged = this.activeTab !== prevTab;
            const branchChanged = (Number(this.selectedBranchId) || null) !== prevBranch;
            if (!tabChanged && !branchChanged) return;
            this.reloadActiveTabData(true);
        },
        activeTab(val, oldVal) {
            if (this.isMinistryPortal) return;
            if (val === 'requests') {
                this.detailPanelOpen = false;
                this.detail = null;
                this.loadRequests(1);
                return;
            }
            if ((val === 'myProducts' || val === 'explore') && oldVal !== undefined && oldVal !== val) {
                this.pageNo = 1;
                this.loadGrid(1);
            }
        },
    },

    data() {
        return {
            activeTab: 'explore',
            branches: [],
            selectedBranchId: null,
            Search: '',
            scopeFilter: 'all',
            filterCategoryId: '',
            filterCodeFrom: '',
            filterCodeRangeFrom: '',
            filterCodeRangeTo: '',
            filterDescriptionSearch: '',
            formularyCategories: [],
            pageNo: 1,
            pageSize: 25,
            pages: 0,
            gridRows: [],
            meta: {
                branchId: null,
                branchName: '',
                hasOpenRequest: false,
                canRequest: false,
                canManageGrants: false,
            },
            basketById: {},
            suppressSelectionSync: false,
            bulkCodesPaste: '',
            pendingExcelFile: null,
            lastResolveUnknown: [],
            resolveBusy: false,
            grantSubmitBusy: false,
            requestForm: { justification: '' },
            requestsList: [],
            requestsPageNo: 1,
            requestsPageSize: 10,
            requestsPages: 0,
            requestStatusFilter: 0,
            detail: null,
            detailPanelOpen: false,
            reviewForm: { approve: true, ministryNote: '' },
            revokeBusyId: null,
        };
    },

    methods: {
        syncFormularyRouteToState() {
            if (!this.isMinistryPortal) return;
            const q = this.$route.query || {};
            const rawBranch = q.facilityBranchesId ?? q.branch;
            const qBranch = rawBranch != null && rawBranch !== '' ? Number(rawBranch) : NaN;
            if (!Number.isNaN(qBranch) && qBranch > 0) {
                this.selectedBranchId = qBranch;
            }
            const view = String(q.view || '').toLowerCase();
            if (view === 'requests') {
                this.activeTab = 'requests';
            } else if (view === 'grant' || view === 'add') {
                this.activeTab = 'explore';
            } else if (!Number.isNaN(qBranch) && qBranch > 0) {
                this.activeTab = 'myProducts';
            } else {
                this.activeTab = 'requests';
            }
        },

        pushFormularyRoute(tab) {
            const q = {};
            if (this.selectedBranchId) q.facilityBranchesId = String(this.selectedBranchId);
            if (tab === 'requests') q.view = 'requests';
            else if (tab === 'explore') q.view = 'grant';
            this.$router.push({ path: '/FacilityNationalFormulary', query: q }).catch(() => {});
        },

        setActiveTab(tab) {
            if (this.isMinistryPortal) {
                if (tab === 'explore' && this.scopeFilter !== 'not_granted') {
                    this.scopeFilter = 'all';
                }
                this.pushFormularyRoute(tab);
                return;
            }
            if (this.activeTab === tab) return;
            if (tab === 'explore') this.scopeFilter = 'all';
            this.activeTab = tab;
        },

        reloadActiveTabData(resetPage) {
            if (resetPage) this.pageNo = 1;
            if (this.activeTab === 'requests') {
                this.detailPanelOpen = false;
                this.detail = null;
                this.loadRequests(1);
                return;
            }
            if (!this.isMinistryPortal || this.selectedBranchId) {
                this.loadGrid(resetPage ? 1 : this.pageNo);
            }
        },

        buildApiFilters() {
            const f = {};
            if (this.filterCategoryId !== '' && this.filterCategoryId != null) {
                const n = Number(this.filterCategoryId);
                if (!Number.isNaN(n) && n > 0) f.categoryId = n;
            }
            const desc = (this.filterDescriptionSearch || '').trim();
            if (desc) f.descriptionSearch = desc;
            const rFrom = (this.filterCodeRangeFrom || '').trim();
            const rTo = (this.filterCodeRangeTo || '').trim();
            const prefix = (this.filterCodeFrom || '').trim();
            if (rFrom && rTo) {
                f.codeFrom = rFrom;
                f.codeTo = rTo;
            } else if (prefix) {
                f.codePrefix = prefix;
                if (rFrom) f.codeFrom = rFrom;
                if (rTo) f.codeTo = rTo;
            } else {
                if (rFrom) f.codeFrom = rFrom;
                if (rTo) f.codeTo = rTo;
            }
            return f;
        },

        clearAdvancedFilters() {
            this.filterCategoryId = '';
            this.filterCodeFrom = '';
            this.filterCodeRangeFrom = '';
            this.filterCodeRangeTo = '';
            this.filterDescriptionSearch = '';
        },

        async loadFormularyCategories() {
            try {
                const res = await this.$http.GetBranchNationalFormularyCategories();
                this.formularyCategories = res.data || [];
            } catch {
                this.formularyCategories = [];
            }
        },

        async loadBranches() {
            this.$blockUI.Start();
            try {
                const res = await this.$http.GetAllBranches();
                this.branches = (res.data && res.data.info) ? res.data.info : (res.data || []);
                const preservedId = Number(this.selectedBranchId) || null;
                if (!preservedId && this.branches.length === 1) {
                    this.selectedBranchId = this.branches[0].id;
                }
            } finally {
                this.$blockUI.Stop();
            }
        },

        onBranchSelected() {
            this.pageNo = 1;
            this.requestsPageNo = 1;
            this.clearBasket();
            if (this.isMinistryPortal) {
                if (!this.selectedBranchId) {
                    this.activeTab = 'requests';
                } else if (this.activeTab === 'requests') {
                    this.activeTab = 'myProducts';
                }
                this.pushFormularyRoute(this.activeTab);
                return;
            }
            this.loadGrid();
            if (this.activeTab === 'requests') this.loadRequests();
        },

        exploreRowSelectable(row) {
            return !row.isGranted && !row.isPendingReview;
        },

        mergeBasketRow(row) {
            if (!row || !row.id) return;
            if (row.isGranted) {
                this.$message.warning('هذا الصنف مفعّل بالفعل للمرفق.');
                return;
            }
            if (row.isPendingReview) {
                this.$message.warning('هذا الصنف ضمن طلب قيد المراجعة.');
                return;
            }
            this.$set(this.basketById, row.id, {
                id: row.id,
                batchNumber: row.batchNumber,
                name: row.name,
                categoryName: row.categoryName,
                isGranted: !!row.isGranted,
                isPendingReview: !!row.isPendingReview,
            });
        },

        mergeBasketFromResolveMatch(m) {
            if (!m || !m.id) return;
            if (m.isGranted) {
                this.$message.warning(`المفعّل سابقاً — تخطّي: ${m.nationalCode}`);
                return;
            }
            if (m.isPendingReview) {
                this.$message.warning(`قيد المراجعة — تخطّي: ${m.nationalCode}`);
                return;
            }
            this.$set(this.basketById, m.id, {
                id: m.id,
                batchNumber: m.nationalCode,
                name: m.scientificName,
                categoryName: m.categoryName,
                isGranted: !!m.isGranted,
                isPendingReview: !!m.isPendingReview,
            });
        },

        removeBasketItem(id) {
            this.$delete(this.basketById, id);
            this.syncExploreTableSelectionFromBasket();
        },

        clearBasket() {
            this.basketById = {};
            this.lastResolveUnknown = [];
            this.syncExploreTableSelectionFromBasket();
        },

        onExploreSelectionChange(val) {
            if (this.suppressSelectionSync) return;
            const sel = new Set((val || []).map((r) => r.id));
            (this.gridRows || []).forEach((row) => {
                if (sel.has(row.id)) this.mergeBasketRow(row);
                else this.$delete(this.basketById, row.id);
            });
        },

        syncExploreTableSelectionFromBasket() {
            this.$nextTick(() => {
                const tb = this.$refs.exploreTable;
                if (!tb || this.activeTab !== 'explore') return;
                this.suppressSelectionSync = true;
                tb.clearSelection();
                (this.gridRows || []).forEach((row) => {
                    if (this.basketById[row.id]) tb.toggleRowSelection(row, true);
                });
                this.$nextTick(() => {
                    this.suppressSelectionSync = false;
                });
            });
        },

        async loadGrid(page) {
            if (page != null && page !== '') this.pageNo = page;
            if (this.isMinistryPortal && !this.selectedBranchId) {
                this.gridRows = [];
                this.pages = 0;
                return;
            }
            this.$blockUI.Start();
            try {
                const filters = this.buildApiFilters();
                const res = await this.$http.GetBranchNationalFormularyGrid(
                    this.pageNo,
                    this.pageSize,
                    this.Search,
                    this.effectiveGridScope,
                    this.branchQueryParam,
                    filters
                );
                this.gridRows = res.data.info || [];
                this.pages = res.data.count || 0;
                this.meta.branchId = res.data.branchId;
                this.meta.branchName = res.data.branchName || '';
                this.meta.hasOpenRequest = !!res.data.hasOpenRequest;
                this.meta.canRequest = !!res.data.canRequest;
                this.meta.canManageGrants = !!res.data.canManageGrants;
                this.syncExploreTableSelectionFromBasket();
            } catch (e) {
                this.gridRows = [];
                this.pages = 0;
                const msg =
                    (e.response && e.response.data && (e.response.data.message || e.response.data)) ||
                    e.message ||
                    'تعذّر تحميل البيانات.';
                this.$message.error(typeof msg === 'string' ? msg : 'تعذّر تحميل البيانات.');
            } finally {
                this.$blockUI.Stop();
            }
        },

        async loadRequests(page) {
            if (page != null && page !== '') this.requestsPageNo = page;
            this.$blockUI.Start();
            try {
                const res = await this.$http.GetBranchNationalFormularyRequests(
                    this.requestsPageNo,
                    this.requestsPageSize,
                    this.requestStatusFilter,
                    this.branchQueryParam
                );
                this.requestsList = res.data.info || [];
                this.requestsPages = res.data.count || 0;
            } finally {
                this.$blockUI.Stop();
            }
        },

        resolveBranchForEnrich() {
            return this.branchQueryParam != null ? this.branchQueryParam : null;
        },

        async resolvePastedCodes() {
            const raw = (this.bulkCodesPaste || '').split(/\r?\n/).map((s) => s.trim()).filter(Boolean);
            if (!raw.length) {
                this.$message.warning('الصق سطراً واحداً على الأقل يحتوي على كود.');
                return;
            }
            this.resolveBusy = true;
            try {
                const res = await this.$http.ResolveBranchNationalFormularyCodes(raw, this.resolveBranchForEnrich());
                const matches = res.data.matches || [];
                this.lastResolveUnknown = res.data.unknownCodes || [];
                let added = 0;
                matches.forEach((m) => {
                    const before = Object.keys(this.basketById).length;
                    this.mergeBasketFromResolveMatch(m);
                    if (Object.keys(this.basketById).length > before) added++;
                });
                this.$message.success(`تمت المطابقة: أضيف ${added} بنداً جديداً للسلة.`);
                this.syncExploreTableSelectionFromBasket();
            } catch (e) {
                const msg =
                    (e.response && e.response.data && (e.response.data.message || e.response.data)) ||
                    e.message ||
                    'تعذّرت المطابقة.';
                this.$message.error(typeof msg === 'string' ? msg : 'تعذّرت المطابقة.');
            } finally {
                this.resolveBusy = false;
            }
        },

        onExcelFileChange(ev) {
            const f = ev.target.files && ev.target.files[0];
            this.pendingExcelFile = f || null;
        },

        async resolveExcelFile() {
            if (!this.pendingExcelFile) {
                this.$message.warning('اختر ملف Excel أولاً.');
                return;
            }
            this.resolveBusy = true;
            try {
                const res = await this.$http.ResolveBranchNationalFormularyCodesExcel(
                    this.pendingExcelFile,
                    this.resolveBranchForEnrich()
                );
                const matches = res.data.matches || [];
                this.lastResolveUnknown = res.data.unknownCodes || [];
                let added = 0;
                matches.forEach((m) => {
                    const before = Object.keys(this.basketById).length;
                    this.mergeBasketFromResolveMatch(m);
                    if (Object.keys(this.basketById).length > before) added++;
                });
                this.$message.success(`تمت قراءة الملف: أضيف ${added} بنداً جديداً للسلة.`);
                this.pendingExcelFile = null;
                this.syncExploreTableSelectionFromBasket();
            } catch (e) {
                const msg =
                    (e.response && e.response.data && (e.response.data.message || e.response.data)) ||
                    e.message ||
                    'تعذّرت قراءة الملف.';
                this.$message.error(typeof msg === 'string' ? msg : 'تعذّرت قراءة الملف.');
            } finally {
                this.resolveBusy = false;
            }
        },

        async submitRequest() {
            const ids = this.basketList.filter((r) => !r.isGranted && !r.isPendingReview).map((r) => r.id);
            if (!ids.length) {
                this.$message.warning('لا توجد أصناف صالحة في السلة (غير مفعّلة وغير قيد المراجعة).');
                return;
            }
            this.$blockUI.Start();
            try {
                await this.$http.CreateBranchNationalFormularyRequest({
                    nationalFormularyItemIds: ids,
                    justification: this.requestForm.justification,
                });
                this.$message.success('تم إرسال الطلب.');
                this.clearBasket();
                this.requestForm.justification = '';
                await this.loadGrid(this.pageNo);
            } catch (e) {
                const msg =
                    (e.response && e.response.data && (e.response.data.message || e.response.data)) ||
                    e.message ||
                    'تعذر إرسال الطلب.';
                this.$message.error(typeof msg === 'string' ? msg : 'تعذر إرسال الطلب.');
            } finally {
                this.$blockUI.Stop();
            }
        },

        async openRequestDetail(row) {
            this.$blockUI.Start();
            try {
                const bid = row && row.branchesId != null ? Number(row.branchesId) : 0;
                const facilityForDetail =
                    this.isMinistryPortal && bid > 0 ? bid : this.branchQueryParam;
                const res = await this.$http.GetBranchNationalFormularyRequestById(row.id, facilityForDetail);
                this.detail = res.data;
                this.reviewForm = { approve: true, ministryNote: '' };
                this.detailPanelOpen = true;
            } catch (e) {
                this.$message.error('تعذر تحميل تفاصيل الطلب.');
            } finally {
                this.$blockUI.Stop();
            }
        },

        closeDetailPanel() {
            this.detailPanelOpen = false;
            this.detail = null;
        },

        async submitReview() {
            if (!this.detail) return;
            this.$blockUI.Start();
            try {
                await this.$http.ReviewBranchNationalFormularyRequest({
                    id: this.detail.id,
                    approve: this.reviewForm.approve,
                    ministryNote: this.reviewForm.ministryNote,
                });
                this.$message.success('تم حفظ القرار.');
                this.closeDetailPanel();
                await this.loadRequests(this.requestsPageNo);
                await this.loadGrid(this.pageNo);
            } catch (e) {
                const msg =
                    (e.response && e.response.data && (e.response.data.message || e.response.data)) ||
                    'تعذر حفظ القرار.';
                this.$message.error(typeof msg === 'string' ? msg : 'تعذر حفظ القرار.');
            } finally {
                this.$blockUI.Stop();
            }
        },

        async submitGrantBasket() {
            if (!this.meta.canManageGrants) {
                this.$message.warning('لا تتوفر صلاحية إدارة المنح.');
                return;
            }
            if (this.isMinistryPortal && !this.selectedBranchId) {
                this.$message.warning('حدد المرفق أولاً.');
                return;
            }
            const rows = this.basketList.filter((x) => !x.isGranted);
            if (!rows.length) {
                this.$message.warning('لا توجد أصناف غير مفعّلة في السلة.');
                return;
            }
            const branchId = this.isMinistryPortal
                ? Number(this.selectedBranchId)
                : Number(this.loginDetails.branchesId);
            this.grantSubmitBusy = true;
            this.$blockUI.Start();
            try {
                await this.$http.BranchNationalFormularyGrantsAdd({
                    facilityBranchesId: branchId,
                    nationalFormularyItemIds: rows.map((r) => r.id),
                });
                this.$message.success('تم التفعيل.');
                this.clearBasket();
                await this.loadGrid(this.pageNo);
            } catch (e) {
                const msg =
                    (e.response && e.response.data && (e.response.data.message || e.response.data)) ||
                    'تعذر التفعيل.';
                this.$message.error(typeof msg === 'string' ? msg : 'تعذر التفعيل.');
            } finally {
                this.grantSubmitBusy = false;
                this.$blockUI.Stop();
            }
        },

        async revokeRow(row) {
            if (!this.meta.canManageGrants) return;
            const branchId = this.isMinistryPortal
                ? Number(this.selectedBranchId)
                : Number(this.loginDetails.branchesId);
            if ((row.stockQuantity || 0) > 0) {
                this.$message.warning('لا يمكن الإلغاء طالما يوجد رصيد في مخازن المرفق.');
                return;
            }
            if (!window.confirm('إلغاء تفعيل هذا الصنف للمرفق؟')) return;
            this.revokeBusyId = row.id;
            try {
                await this.$http.BranchNationalFormularyGrantsRevoke({
                    facilityBranchesId: branchId,
                    nationalFormularyItemId: row.id,
                });
                this.$message.success('تم إلغاء التفعيل.');
                await this.loadGrid(this.pageNo);
            } catch (e) {
                const msg =
                    (e.response && e.response.data && (e.response.data.message || e.response.data)) ||
                    'تعذر الإلغاء.';
                this.$message.error(typeof msg === 'string' ? msg : 'تعذر الإلغاء.');
            } finally {
                this.revokeBusyId = null;
            }
        },

        requestStatusBadge(s) {
            const n = Number(s);
            if (n === 2) return 'bg-label-success';
            if (n === 3) return 'bg-label-danger';
            if (n === 1) return 'bg-label-warning';
            return 'bg-label-secondary';
        },

        goProductStock(row) {
            const q = (row && row.batchNumber) ? String(row.batchNumber) : '';
            this.$router.push({ path: '/ProductsCounts', query: { search: q } });
        },

        goDirectReceive() {
            this.$router.push({ path: '/DirectDispatchReceive' });
        },

        /** انتقال سريع إلى استكشاف القائمة النمطية لاختيار أصناف غير مفعّلة ثم التفعيل من السلة. */
        openExploreForMinistryGrant() {
            this.scopeFilter = 'not_granted';
            this.setActiveTab('explore');
        },
    },
};
